import { render, staticRenderFns } from "./BaseSection.vue?vue&type=template&id=cf55aeca&scoped=true&"
import script from "./BaseSection.vue?vue&type=script&lang=js&"
export * from "./BaseSection.vue?vue&type=script&lang=js&"
import style0 from "./BaseSection.vue?vue&type=style&index=0&id=cf55aeca&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf55aeca",
  null
  
)

export default component.exports